<template>
  <div>
    <div v-if="!selecionouIcmsInterno">
      <div class="icms-interno-content" v-for="(subimposto, index) in dadosIcms">
        <RadioButton
          v-if="dadosIcms.length > 1"
          :classe="classe"
          :seleciona="seleciona"
          :imposto="subimposto"
          :name="'radio'"
          :loading="loading"
        />
        <Registro :paddingSemCheckBox="dadosIcms.length <= 1">
          <Cabecalho
            :tipo="!!subimposto.blSimplesNacional ? 'porcentagem5' : ''"
            :titulo="subimposto.label"
            :aliquota="aliquota(subimposto)"
          />
          <div class="separador" />
          <Memoria :titulo="'Memória de cálculo:'" :memoria="subimposto.memoria" />
          <div v-if="subimposto.memoria" class="separador" />

          <Cabecalho
            v-if="subimposto.aliquota_excedente"
            :tipo="!!subimposto.blSimplesNacional ? 'porcentagem5' : ''"
            :titulo="subimposto.label_excedente"
            :aliquota="subimposto.aliquota_excedente"
          />

          <Separador
            v-if="
              !subimposto.blSimplesNacional &&
                subimposto.ncm &&
                !(subimposto.label == 'Alíquota Regra Geral' || subimposto.regra_geral == 1) &&
                subimposto.label_excedente
            "
            :dado="subimposto"
          />
          <!-- NECESSITA VERIFICAR SE QUANDO O CÁLCULO DO SIMPLES É FEITO POR FORA O BLSIMPLESNACIONAL VEM 1 OU NULL -->
          <Ncm
            v-if="
              !subimposto.blSimplesNacional &&
                !(subimposto.label == 'Alíquota Regra Geral' || subimposto.regra_geral == 1) &&
                !subimposto.label_excedente &&
                !similarNacionalFiltrado(subimposto).length
            "
            :ncm="subimposto.ncm"
          />
          <Ncm
            v-else-if="similarNacionalFiltrado(subimposto).length == 1"
            :ncm="similarNacionalFiltrado(subimposto)[0].ncm"
          />
          <Ncm v-else-if="ncmBssn" :ncm="ncmBssn" />
          <Separador
            v-if="
              !subimposto.blSimplesNacional &&
                !(subimposto.label == 'Alíquota Regra Geral' || subimposto.regra_geral == 1) &&
                !subimposto.label_excedente &&
                !similarNacionalFiltrado(subimposto).length &&
                subimposto.ncm
            "
            :dado="subimposto"
          />
          <Separador
            v-else-if="similarNacionalFiltrado(subimposto).length == 1"
            :dado="subimposto"
          />
          <Separador v-else-if="ncmBssn && !!similarNacionalFiltrado(subimposto).length" :dado="subimposto" />

          <div v-if="!similarNacionalFiltrado(subimposto).length">
            <Descricao :titulo="'Descrição'" :descricao="subimposto.descricao" />
          </div>
          <div v-else-if="similarNacionalFiltrado(subimposto).length == 1">
            <Descricao
              :titulo="'Descrição'"
              :descricao="similarNacionalFiltrado(subimposto)[0].descricao"
            />
            <div class="botao-container" v-b-tooltip.hover.top :title="'Item pré-selecionado'">
              <button
                disabled
                class="similar-button no-print botao-desabilitado"
                @click="abreModalSimilar(subimposto)"
              >
                Bens Sem Similar Nacional
              </button>
            </div>
          </div>
          <div v-else>
            <Descricao :titulo="'Descrição'" :descricao="descricaoBssn" />
            <button class="similar-button no-print" @click="abreModalSimilar(subimposto)">
              Bens Sem Similar Nacional
            </button>
          </div>
          <div class="separador" v-if="subimposto.descricao" />

          <div class="separador" v-if="subimposto.memoria_excedente" />
          <Memoria :titulo="'Memória de cálculo:'" :memoria="subimposto.memoria_excedente" />
          <div class="separador" v-if="subimposto.memoria_excedente" />

          <Cabecalho
            v-if="subimposto.vigencia_fim"
            :titulo="'Vigência'"
            tipo="data"
            :aliquota="subimposto.vigencia_fim"
          />
          <div>
            <Notificacao v-if="subimposto.alerta" :tipo="'alerta'" :texto="subimposto.alerta" />
            <GrupoNotificacao v-if="subimposto" :registro="subimposto" />
          </div>
          <div
            class="separador"
            v-if="
              subimposto.vigencia_fim ||
                subimposto.obs_aplic ||
                subimposto.obs_inaplic ||
                subimposto.obs ||
                subimposto.alerta
            "
            :dado="subimposto"
          />

          <BaseLegal
            v-if="!similarNacionalFiltrado(subimposto).length"
            :base_legal="subimposto.base_legal"
            :classe="classe"
          />
          <BaseLegal
            v-else-if="similarNacionalFiltrado(subimposto).length == 1"
            :base_legal="concatenaBaseBssn(subimposto)"
            :classe="classe"
          />
          <BaseLegal
            v-else
            :base_legal="baseBssn ? concatenaBaseBssn(subimposto) : subimposto.base_legal"
            :classe="classe"
          />
        </Registro>
      </div>
    </div>

    <div :key="getRenderKey" v-else>
      <div class="icms-interno-content">
        <EditButton
          v-if="dadosIcms.length > 1"
          :edita="edita"
          :classe="classe"
          :loading="loading"
        />
        <Registro :paddingSemCheckBox="dadosIcms.length <= 1">
          <Cabecalho
            :tipo="!!selecionado.blSimplesNacional ? 'porcentagem5' : ''"
            :titulo="selecionado.label"
            :aliquota="aliquota(selecionado)"
          />
          <Separador :dado="selecionado" />
          <Memoria :titulo="'Memória de cálculo:'" :memoria="selecionado.memoria" />

          <Separador v-if="selecionado.memoria" :dado="selecionado" />

          <Cabecalho
            v-if="selecionado.aliquota_excedente"
            :tipo="!!selecionado.blSimplesNacional ? 'porcentagem5' : ''"
            :titulo="selecionado.label_excedente"
            :aliquota="selecionado.aliquota_excedente"
          />

          <Separador
            v-if="
              !selecionado.blSimplesNacional &&
                selecionado.ncm &&
                !(selecionado.label == 'Alíquota Regra Geral' || selecionado.regra_geral == 1) &&
                selecionado.label_excedente
            "
            :dado="selecionado"
          />
          <!-- NECESSITA VERIFICAR SE QUANDO O CÁLCULO DO SIMPLES É FEITO POR FORA O BLSIMPLESNACIONAL VEM 1 OU NULL -->
          <Ncm
            v-if="
              !selecionado.blSimplesNacional &&
                !(selecionado.label == 'Alíquota Regra Geral' || selecionado.regra_geral == 1) &&
                !selecionado.label_excedente &&
                !similarNacionalFiltrado(selecionado).length
            "
            :ncm="selecionado.ncm"
          />
          <Ncm
            v-else-if="similarNacionalFiltrado(selecionado).length == 1"
            :ncm="similarNacionalFiltrado(selecionado)[0].ncm"
          />
          <Ncm v-else-if="ncmBssn" :ncm="ncmBssn" />
          <Separador
            v-if="
              !selecionado.blSimplesNacional &&
                !(selecionado.label == 'Alíquota Regra Geral' || selecionado.regra_geral == 1) &&
                !selecionado.label_excedente &&
                !similarNacionalFiltrado(selecionado).length &&
                selecionado.ncm
            "
            :dado="selecionado"
          />
          <Separador
            v-else-if="similarNacionalFiltrado(selecionado).length == 1"
            :dado="selecionado"
          />
          <Separador v-else-if="ncmBssn && !!similarNacionalFiltrado(selecionado).length" :dado="selecionado" />

          <div v-if="!similarNacionalFiltrado(selecionado).length">
            <Descricao :titulo="'Descrição'" :descricao="selecionado.descricao" />
          </div>
          <div v-else-if="similarNacionalFiltrado(selecionado).length == 1">
            <Descricao
              :titulo="'Descrição'"
              :descricao="similarNacionalFiltrado(selecionado)[0].descricao"
            />
            <div class="botao-container" v-b-tooltip.hover.top :title="'Item pré-selecionado'">
              <button
                disabled
                class="similar-button no-print botao-desabilitado"
                @click="abreModalSimilar(subimposto)"
              >
                Bens Sem Similar Nacional
              </button>
            </div>
          </div>
          <div v-else>
            <Descricao :titulo="'Descrição'" :descricao="descricaoBssn" />
            <button class="similar-button no-print" @click="abreModalSimilar(selecionado)">
              Bens Sem Similar Nacional
            </button>
          </div>
          <Separador :dado="selecionado.descricao" />

          <Separador :dado="selecionado.memoria_excedente" />
          <Memoria :titulo="'Memória de cálculo:'" :memoria="selecionado.memoria_excedente" />
          <Separador :dado="selecionado.memoria_excedente" />

          <Cabecalho
            v-if="selecionado.vigencia_fim"
            :titulo="'Vigência'"
            tipo="data"
            :aliquota="selecionado.vigencia_fim"
          />
          <div>
            <Notificacao v-if="selecionado.alerta" :tipo="'alerta'" :texto="selecionado.alerta" />
            <GrupoNotificacao v-if="selecionado" :registro="selecionado" />
          </div>
          <Separador
            v-if="
              selecionado.vigencia_fim ||
                selecionado.alerta ||
                selecionado.nota ||
                selecionado.obs_aplic ||
                selecionado.obs_inaplic ||
                selecionado.obs
            "
            :dado="selecionado"
          />

          <BaseLegal
            v-if="!similarNacionalFiltrado(selecionado).length"
            :base_legal="selecionado.base_legal"
            :classe="classe"
          />
          <BaseLegal
            v-else-if="similarNacionalFiltrado(selecionado).length == 1"
            :base_legal="concatenaBaseBssn(selecionado)"
            :classe="classe"
          />
          <BaseLegal
            v-else
            :base_legal="baseBssn ? concatenaBaseBssn(selecionado) : selecionado.base_legal"
            :classe="classe"
          />
        </Registro>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Memoria from "../Memoria/Memoria.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import ModalIcmsInterestadual from "@/components/ModalIcmsInterestadual/ModalIcmsInterestadual.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import { mapGetters } from "vuex";
export default {
  name: "RegistrosIcmsInterno",

  props: {
    edita: Function,
    id: String | Number,
    classe: String,
    bssnSelecionado: Array,
    imposto: Object | Array,
    loading: Boolean,
    reduzAliquota: String | Number,
    seleciona: Function,
    selecionado: Object,
    selecionouIcmsInterno: Boolean,
    quadroSecundario: Boolean
  },
  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    EditButton,
    QuadroPrincipal,
    RadioButton,
    Registro,
    GrupoNotificacao,
    Separador,
    Memoria,
    Ncm,
    Notificacao,
    ModalIcmsInterestadual
  },
  mixins: [stringFormatMixin],
  inject: ["modalSimilarToggle", "getDadosModalBssn", "limpaSimilar"],

  data() {
    return {
      similarNacionalAliquota: null,
      similarSelecionado: []
    };
  },

  created() {
    //se tiver apenas um resultado, seleciona o mesmo.
    if (this.imposto && this.dadosIcms.length == 1) {
      this.seleciona(this.dadosIcms[0]);
    }
  },
  beforeDestroy() {
    this.limpaSimilar(this.id);
  },

  // updated() {
  //   //se tiver apenas um resultado, seleciona o mesmo.
  //   if (this.imposto && this.dadosIcms.length == 1) {
  //     this.seleciona(this.dadosIcms[0]);
  //   }
  // },
  watch: {
    similarNacionalAliquota() {
      this.getDadosModalBssn(this.id, this.similarNacionalAliquota);
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    dadosIcms: function() {
      return this.quadroSecundario ? this.imposto.icms : this.imposto.dados;
    },
    ncmBssn() {
      let ncm =
        this.bssnSelecionado && this.bssnSelecionado.find(f => f.id == this.id)
          ? this.bssnSelecionado.find(f => f.id == this.id).selecionado.ncm
          : null;
      return ncm;
    },
    descricaoBssn() {
      let descricao =
        this.bssnSelecionado && this.bssnSelecionado.find(f => f.id == this.id)
          ? this.bssnSelecionado.find(f => f.id == this.id).selecionado.descricao
          : null;
      return descricao;
    },
    baseBssn() {
      let base =
        this.bssnSelecionado && this.bssnSelecionado.find(f => f.id == this.id)
          ? this.bssnSelecionado.find(f => f.id == this.id).selecionado.base_legal
          : null;
      return base;
    }
  },

  methods: {
    concatenaBaseBssn(registro) {
      if (this.similarNacionalFiltrado(registro).length == 1) {
        let base = `${registro.base_legal} | ${
          this.similarNacionalFiltrado(registro)[0].base_legal
        }`;
        return base;
      }
      let base = `${registro.base_legal} | ${this.baseBssn}`;
      return base;
    },
    abreModalSimilar(dado) {
      this.similarNacionalAliquota = this.similarNacionalFiltrado(dado);
      this.modalSimilarToggle();
    },
    similarNacionalFiltrado(dado) {
      let similares = dado.similares ? dado.similares.filter(f => f.valida_similar == 1) : [];
      return similares;
    },
    medidaAplicada(dado) {
      let semPorcentagem = this.strReplace(dado.medida_aplicada, "%", "");
      let ponto = this.strReplace(semPorcentagem, ",", ".");
      let resposta = Number(ponto);
      return resposta;
    },

    aliquotaModificada(subimposto) {
      //corrige diferença de alíquota quando é simples nacional
      if (subimposto.aliquota) {
        return subimposto.aliquota;
      } else {
        return subimposto.medida_aplicada.replace(",", ".").replace("%", "");
      }
    },

    aliquota(dado) {
      if (dado.aliquota) {
        return dado.aliquota ? dado.aliquota - this.reduzAliquota : null;
      }
      return this.medidaAplicada(dado) ? this.medidaAplicada(dado) - this.reduzAliquota : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.icms-interno-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
.similar-button {
  // margin-top: 0.5rem;
  margin-top: 7px;
  padding: 4px 8px;

  font-weight: bold;
  text-decoration: none !important;

  background: #72b118;
  color: var(--branco);
  border-radius: 4px;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }
}
.botao-desabilitado {
  opacity: 0.5;
}
.botao-container {
  width: fit-content;
}
</style>
